import React from 'react';
import PropTypes from 'prop-types';

class SuccessAlert extends React.Component {
  render() {
    const message = this.props.message;

    return (
      <span style={{color: 'green'}}>
        {message}
      </span>
    );
  };
}

SuccessAlert.propTypes = {
  message: PropTypes.isRequired,
  message: PropTypes.string,
};

export default SuccessAlert;
